/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EbayIntPutObject = {
  value?: number | null;
};
export type EbayArray_StringRequired_RequiredPutObject = {
  value: Array<string>;
};
export type EbayStringPutObject = {
  value?: string | null;
};
export type EbayStringRequiredPutObject = {
  value: string;
};
export type EbayBooleanRequiredPutObject = {
  value: boolean;
};
export type putEbayListingMutationVariables = {
  listingId: string;
  categoryId?: EbayIntPutObject | null;
  pictureIds?: EbayArray_StringRequired_RequiredPutObject | null;
  price?: EbayIntPutObject | null;
  condition?: EbayStringPutObject | null;
  title?: EbayStringPutObject | null;
  description?: EbayStringPutObject | null;
  attributes?: EbayStringRequiredPutObject | null;
  upc?: EbayStringPutObject | null;
  isbn?: EbayStringPutObject | null;
  attributesBrand?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesColor?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesStyle?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesItemHeight?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesItemLength?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesItemWidth?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesType?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesMaterial?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesNumberOfItemsInSet?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesSetIncludes?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesBandMaterial?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesDepartment?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesDressLength?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesOuterShellMaterial?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesFrameColor?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesUpperMaterial?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesInseam?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesSleeveLength?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesDesignerBrand?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesExteriorMaterial?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesExteriorColor?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesSkirtLength?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesMainStone?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesMetalPurity?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesMetal?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesBeadSize?: EbayArray_StringRequired_RequiredPutObject | null;
  attributesRingSize?: EbayArray_StringRequired_RequiredPutObject | null;
  shippingPolicyId?: EbayStringPutObject | null;
  shippingPrimaryServicePaymentType?: EbayStringPutObject | null;
  domesticShippingService1?: EbayStringPutObject | null;
  domesticShippingPrice1?: EbayIntPutObject | null;
  shippingIntlPrimaryServicePaymentType?: EbayStringPutObject | null;
  intlShippingService1?: EbayStringPutObject | null;
  intlShippingPrice1?: EbayIntPutObject | null;
  offerGlobalShipping?: EbayBooleanRequiredPutObject | null;
  offerLocalPickup?: EbayBooleanRequiredPutObject | null;
  localPickupPrice?: EbayIntPutObject | null;
};
export type putEbayListingMutationResponse = {
  readonly ebayPutEbayListing: {
    readonly success: boolean;
  } | null;
};
export type putEbayListingMutation = {
  readonly response: putEbayListingMutationResponse;
  readonly variables: putEbayListingMutationVariables;
};

/*
mutation putEbayListingMutation(
  $listingId: String!
  $categoryId: EbayIntPutObject
  $pictureIds: EbayArray_StringRequired_RequiredPutObject
  $price: EbayIntPutObject
  $condition: EbayStringPutObject
  $title: EbayStringPutObject
  $description: EbayStringPutObject
  $attributes: EbayStringRequiredPutObject
  $upc: EbayStringPutObject
  $isbn: EbayStringPutObject
  $attributesBrand: EbayArray_StringRequired_RequiredPutObject
  $attributesColor: EbayArray_StringRequired_RequiredPutObject
  $attributesStyle: EbayArray_StringRequired_RequiredPutObject
  $attributesItemHeight: EbayArray_StringRequired_RequiredPutObject
  $attributesItemLength: EbayArray_StringRequired_RequiredPutObject
  $attributesItemWidth: EbayArray_StringRequired_RequiredPutObject
  $attributesType: EbayArray_StringRequired_RequiredPutObject
  $attributesMaterial: EbayArray_StringRequired_RequiredPutObject
  $attributesNumberOfItemsInSet: EbayArray_StringRequired_RequiredPutObject
  $attributesSetIncludes: EbayArray_StringRequired_RequiredPutObject
  $attributesBandMaterial: EbayArray_StringRequired_RequiredPutObject
  $attributesDepartment: EbayArray_StringRequired_RequiredPutObject
  $attributesDressLength: EbayArray_StringRequired_RequiredPutObject
  $attributesOuterShellMaterial: EbayArray_StringRequired_RequiredPutObject
  $attributesFrameColor: EbayArray_StringRequired_RequiredPutObject
  $attributesUpperMaterial: EbayArray_StringRequired_RequiredPutObject
  $attributesInseam: EbayArray_StringRequired_RequiredPutObject
  $attributesSleeveLength: EbayArray_StringRequired_RequiredPutObject
  $attributesDesignerBrand: EbayArray_StringRequired_RequiredPutObject
  $attributesExteriorMaterial: EbayArray_StringRequired_RequiredPutObject
  $attributesExteriorColor: EbayArray_StringRequired_RequiredPutObject
  $attributesSkirtLength: EbayArray_StringRequired_RequiredPutObject
  $attributesMainStone: EbayArray_StringRequired_RequiredPutObject
  $attributesMetalPurity: EbayArray_StringRequired_RequiredPutObject
  $attributesMetal: EbayArray_StringRequired_RequiredPutObject
  $attributesBeadSize: EbayArray_StringRequired_RequiredPutObject
  $attributesRingSize: EbayArray_StringRequired_RequiredPutObject
  $shippingPolicyId: EbayStringPutObject
  $shippingPrimaryServicePaymentType: EbayStringPutObject
  $domesticShippingService1: EbayStringPutObject
  $domesticShippingPrice1: EbayIntPutObject
  $shippingIntlPrimaryServicePaymentType: EbayStringPutObject
  $intlShippingService1: EbayStringPutObject
  $intlShippingPrice1: EbayIntPutObject
  $offerGlobalShipping: EbayBooleanRequiredPutObject
  $offerLocalPickup: EbayBooleanRequiredPutObject
  $localPickupPrice: EbayIntPutObject
) {
  ebayPutEbayListing(listingId: $listingId, categoryId: $categoryId, pictureIds: $pictureIds, price: $price, condition: $condition, title: $title, description: $description, attributes: $attributes, upc: $upc, isbn: $isbn, attributesBrand: $attributesBrand, attributesColor: $attributesColor, attributesStyle: $attributesStyle, attributesItemHeight: $attributesItemHeight, attributesItemLength: $attributesItemLength, attributesItemWidth: $attributesItemWidth, attributesType: $attributesType, attributesMaterial: $attributesMaterial, attributesNumberOfItemsInSet: $attributesNumberOfItemsInSet, attributesSetIncludes: $attributesSetIncludes, attributesBandMaterial: $attributesBandMaterial, attributesDepartment: $attributesDepartment, attributesDressLength: $attributesDressLength, attributesOuterShellMaterial: $attributesOuterShellMaterial, attributesFrameColor: $attributesFrameColor, attributesUpperMaterial: $attributesUpperMaterial, attributesInseam: $attributesInseam, attributesSleeveLength: $attributesSleeveLength, attributesDesignerBrand: $attributesDesignerBrand, attributesExteriorMaterial: $attributesExteriorMaterial, attributesExteriorColor: $attributesExteriorColor, attributesSkirtLength: $attributesSkirtLength, attributesMainStone: $attributesMainStone, attributesMetalPurity: $attributesMetalPurity, attributesMetal: $attributesMetal, attributesBeadSize: $attributesBeadSize, attributesRingSize: $attributesRingSize, shippingPolicyId: $shippingPolicyId, shippingPrimaryServicePaymentType: $shippingPrimaryServicePaymentType, domesticShippingService1: $domesticShippingService1, domesticShippingPrice1: $domesticShippingPrice1, shippingIntlPrimaryServicePaymentType: $shippingIntlPrimaryServicePaymentType, intlShippingService1: $intlShippingService1, intlShippingPrice1: $intlShippingPrice1, offerGlobalShipping: $offerGlobalShipping, offerLocalPickup: $offerLocalPickup, localPickupPrice: $localPickupPrice) {
    success
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributes',
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesBandMaterial',
    },
    v2 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesBeadSize',
    },
    v3 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesBrand',
    },
    v4 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesColor',
    },
    v5 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesDepartment',
    },
    v6 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesDesignerBrand',
    },
    v7 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesDressLength',
    },
    v8 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesExteriorColor',
    },
    v9 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesExteriorMaterial',
    },
    v10 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesFrameColor',
    },
    v11 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesInseam',
    },
    v12 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesItemHeight',
    },
    v13 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesItemLength',
    },
    v14 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesItemWidth',
    },
    v15 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesMainStone',
    },
    v16 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesMaterial',
    },
    v17 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesMetal',
    },
    v18 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesMetalPurity',
    },
    v19 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesNumberOfItemsInSet',
    },
    v20 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesOuterShellMaterial',
    },
    v21 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesRingSize',
    },
    v22 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesSetIncludes',
    },
    v23 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesSkirtLength',
    },
    v24 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesSleeveLength',
    },
    v25 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesStyle',
    },
    v26 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesType',
    },
    v27 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'attributesUpperMaterial',
    },
    v28 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'categoryId',
    },
    v29 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'condition',
    },
    v30 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'description',
    },
    v31 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'domesticShippingPrice1',
    },
    v32 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'domesticShippingService1',
    },
    v33 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'intlShippingPrice1',
    },
    v34 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'intlShippingService1',
    },
    v35 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'isbn',
    },
    v36 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'listingId',
    },
    v37 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'localPickupPrice',
    },
    v38 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'offerGlobalShipping',
    },
    v39 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'offerLocalPickup',
    },
    v40 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'pictureIds',
    },
    v41 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'price',
    },
    v42 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'shippingIntlPrimaryServicePaymentType',
    },
    v43 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'shippingPolicyId',
    },
    v44 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'shippingPrimaryServicePaymentType',
    },
    v45 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'title',
    },
    v46 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'upc',
    },
    v47 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'attributes',
            variableName: 'attributes',
          },
          {
            kind: 'Variable',
            name: 'attributesBandMaterial',
            variableName: 'attributesBandMaterial',
          },
          {
            kind: 'Variable',
            name: 'attributesBeadSize',
            variableName: 'attributesBeadSize',
          },
          {
            kind: 'Variable',
            name: 'attributesBrand',
            variableName: 'attributesBrand',
          },
          {
            kind: 'Variable',
            name: 'attributesColor',
            variableName: 'attributesColor',
          },
          {
            kind: 'Variable',
            name: 'attributesDepartment',
            variableName: 'attributesDepartment',
          },
          {
            kind: 'Variable',
            name: 'attributesDesignerBrand',
            variableName: 'attributesDesignerBrand',
          },
          {
            kind: 'Variable',
            name: 'attributesDressLength',
            variableName: 'attributesDressLength',
          },
          {
            kind: 'Variable',
            name: 'attributesExteriorColor',
            variableName: 'attributesExteriorColor',
          },
          {
            kind: 'Variable',
            name: 'attributesExteriorMaterial',
            variableName: 'attributesExteriorMaterial',
          },
          {
            kind: 'Variable',
            name: 'attributesFrameColor',
            variableName: 'attributesFrameColor',
          },
          {
            kind: 'Variable',
            name: 'attributesInseam',
            variableName: 'attributesInseam',
          },
          {
            kind: 'Variable',
            name: 'attributesItemHeight',
            variableName: 'attributesItemHeight',
          },
          {
            kind: 'Variable',
            name: 'attributesItemLength',
            variableName: 'attributesItemLength',
          },
          {
            kind: 'Variable',
            name: 'attributesItemWidth',
            variableName: 'attributesItemWidth',
          },
          {
            kind: 'Variable',
            name: 'attributesMainStone',
            variableName: 'attributesMainStone',
          },
          {
            kind: 'Variable',
            name: 'attributesMaterial',
            variableName: 'attributesMaterial',
          },
          {
            kind: 'Variable',
            name: 'attributesMetal',
            variableName: 'attributesMetal',
          },
          {
            kind: 'Variable',
            name: 'attributesMetalPurity',
            variableName: 'attributesMetalPurity',
          },
          {
            kind: 'Variable',
            name: 'attributesNumberOfItemsInSet',
            variableName: 'attributesNumberOfItemsInSet',
          },
          {
            kind: 'Variable',
            name: 'attributesOuterShellMaterial',
            variableName: 'attributesOuterShellMaterial',
          },
          {
            kind: 'Variable',
            name: 'attributesRingSize',
            variableName: 'attributesRingSize',
          },
          {
            kind: 'Variable',
            name: 'attributesSetIncludes',
            variableName: 'attributesSetIncludes',
          },
          {
            kind: 'Variable',
            name: 'attributesSkirtLength',
            variableName: 'attributesSkirtLength',
          },
          {
            kind: 'Variable',
            name: 'attributesSleeveLength',
            variableName: 'attributesSleeveLength',
          },
          {
            kind: 'Variable',
            name: 'attributesStyle',
            variableName: 'attributesStyle',
          },
          {
            kind: 'Variable',
            name: 'attributesType',
            variableName: 'attributesType',
          },
          {
            kind: 'Variable',
            name: 'attributesUpperMaterial',
            variableName: 'attributesUpperMaterial',
          },
          {
            kind: 'Variable',
            name: 'categoryId',
            variableName: 'categoryId',
          },
          {
            kind: 'Variable',
            name: 'condition',
            variableName: 'condition',
          },
          {
            kind: 'Variable',
            name: 'description',
            variableName: 'description',
          },
          {
            kind: 'Variable',
            name: 'domesticShippingPrice1',
            variableName: 'domesticShippingPrice1',
          },
          {
            kind: 'Variable',
            name: 'domesticShippingService1',
            variableName: 'domesticShippingService1',
          },
          {
            kind: 'Variable',
            name: 'intlShippingPrice1',
            variableName: 'intlShippingPrice1',
          },
          {
            kind: 'Variable',
            name: 'intlShippingService1',
            variableName: 'intlShippingService1',
          },
          {
            kind: 'Variable',
            name: 'isbn',
            variableName: 'isbn',
          },
          {
            kind: 'Variable',
            name: 'listingId',
            variableName: 'listingId',
          },
          {
            kind: 'Variable',
            name: 'localPickupPrice',
            variableName: 'localPickupPrice',
          },
          {
            kind: 'Variable',
            name: 'offerGlobalShipping',
            variableName: 'offerGlobalShipping',
          },
          {
            kind: 'Variable',
            name: 'offerLocalPickup',
            variableName: 'offerLocalPickup',
          },
          {
            kind: 'Variable',
            name: 'pictureIds',
            variableName: 'pictureIds',
          },
          {
            kind: 'Variable',
            name: 'price',
            variableName: 'price',
          },
          {
            kind: 'Variable',
            name: 'shippingIntlPrimaryServicePaymentType',
            variableName: 'shippingIntlPrimaryServicePaymentType',
          },
          {
            kind: 'Variable',
            name: 'shippingPolicyId',
            variableName: 'shippingPolicyId',
          },
          {
            kind: 'Variable',
            name: 'shippingPrimaryServicePaymentType',
            variableName: 'shippingPrimaryServicePaymentType',
          },
          {
            kind: 'Variable',
            name: 'title',
            variableName: 'title',
          },
          {
            kind: 'Variable',
            name: 'upc',
            variableName: 'upc',
          },
        ],
        concreteType: 'EbayPutEbayListingResponse',
        kind: 'LinkedField',
        name: 'ebayPutEbayListing',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [
        v0 /*: any*/,
        v1 /*: any*/,
        v2 /*: any*/,
        v3 /*: any*/,
        v4 /*: any*/,
        v5 /*: any*/,
        v6 /*: any*/,
        v7 /*: any*/,
        v8 /*: any*/,
        v9 /*: any*/,
        v10 /*: any*/,
        v11 /*: any*/,
        v12 /*: any*/,
        v13 /*: any*/,
        v14 /*: any*/,
        v15 /*: any*/,
        v16 /*: any*/,
        v17 /*: any*/,
        v18 /*: any*/,
        v19 /*: any*/,
        v20 /*: any*/,
        v21 /*: any*/,
        v22 /*: any*/,
        v23 /*: any*/,
        v24 /*: any*/,
        v25 /*: any*/,
        v26 /*: any*/,
        v27 /*: any*/,
        v28 /*: any*/,
        v29 /*: any*/,
        v30 /*: any*/,
        v31 /*: any*/,
        v32 /*: any*/,
        v33 /*: any*/,
        v34 /*: any*/,
        v35 /*: any*/,
        v36 /*: any*/,
        v37 /*: any*/,
        v38 /*: any*/,
        v39 /*: any*/,
        v40 /*: any*/,
        v41 /*: any*/,
        v42 /*: any*/,
        v43 /*: any*/,
        v44 /*: any*/,
        v45 /*: any*/,
        v46 /*: any*/,
      ],
      kind: 'Fragment',
      metadata: null,
      name: 'putEbayListingMutation',
      selections: v47 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [
        v36 /*: any*/,
        v28 /*: any*/,
        v40 /*: any*/,
        v41 /*: any*/,
        v29 /*: any*/,
        v45 /*: any*/,
        v30 /*: any*/,
        v0 /*: any*/,
        v46 /*: any*/,
        v35 /*: any*/,
        v3 /*: any*/,
        v4 /*: any*/,
        v25 /*: any*/,
        v12 /*: any*/,
        v13 /*: any*/,
        v14 /*: any*/,
        v26 /*: any*/,
        v16 /*: any*/,
        v19 /*: any*/,
        v22 /*: any*/,
        v1 /*: any*/,
        v5 /*: any*/,
        v7 /*: any*/,
        v20 /*: any*/,
        v10 /*: any*/,
        v27 /*: any*/,
        v11 /*: any*/,
        v24 /*: any*/,
        v6 /*: any*/,
        v9 /*: any*/,
        v8 /*: any*/,
        v23 /*: any*/,
        v15 /*: any*/,
        v18 /*: any*/,
        v17 /*: any*/,
        v2 /*: any*/,
        v21 /*: any*/,
        v43 /*: any*/,
        v44 /*: any*/,
        v32 /*: any*/,
        v31 /*: any*/,
        v42 /*: any*/,
        v34 /*: any*/,
        v33 /*: any*/,
        v38 /*: any*/,
        v39 /*: any*/,
        v37 /*: any*/,
      ],
      kind: 'Operation',
      name: 'putEbayListingMutation',
      selections: v47 /*: any*/,
    },
    params: {
      cacheID: '545693bb742ffc2be3d5137ba550b22f',
      id: null,
      metadata: {},
      name: 'putEbayListingMutation',
      operationKind: 'mutation',
      text: 'mutation putEbayListingMutation(\n  $listingId: String!\n  $categoryId: EbayIntPutObject\n  $pictureIds: EbayArray_StringRequired_RequiredPutObject\n  $price: EbayIntPutObject\n  $condition: EbayStringPutObject\n  $title: EbayStringPutObject\n  $description: EbayStringPutObject\n  $attributes: EbayStringRequiredPutObject\n  $upc: EbayStringPutObject\n  $isbn: EbayStringPutObject\n  $attributesBrand: EbayArray_StringRequired_RequiredPutObject\n  $attributesColor: EbayArray_StringRequired_RequiredPutObject\n  $attributesStyle: EbayArray_StringRequired_RequiredPutObject\n  $attributesItemHeight: EbayArray_StringRequired_RequiredPutObject\n  $attributesItemLength: EbayArray_StringRequired_RequiredPutObject\n  $attributesItemWidth: EbayArray_StringRequired_RequiredPutObject\n  $attributesType: EbayArray_StringRequired_RequiredPutObject\n  $attributesMaterial: EbayArray_StringRequired_RequiredPutObject\n  $attributesNumberOfItemsInSet: EbayArray_StringRequired_RequiredPutObject\n  $attributesSetIncludes: EbayArray_StringRequired_RequiredPutObject\n  $attributesBandMaterial: EbayArray_StringRequired_RequiredPutObject\n  $attributesDepartment: EbayArray_StringRequired_RequiredPutObject\n  $attributesDressLength: EbayArray_StringRequired_RequiredPutObject\n  $attributesOuterShellMaterial: EbayArray_StringRequired_RequiredPutObject\n  $attributesFrameColor: EbayArray_StringRequired_RequiredPutObject\n  $attributesUpperMaterial: EbayArray_StringRequired_RequiredPutObject\n  $attributesInseam: EbayArray_StringRequired_RequiredPutObject\n  $attributesSleeveLength: EbayArray_StringRequired_RequiredPutObject\n  $attributesDesignerBrand: EbayArray_StringRequired_RequiredPutObject\n  $attributesExteriorMaterial: EbayArray_StringRequired_RequiredPutObject\n  $attributesExteriorColor: EbayArray_StringRequired_RequiredPutObject\n  $attributesSkirtLength: EbayArray_StringRequired_RequiredPutObject\n  $attributesMainStone: EbayArray_StringRequired_RequiredPutObject\n  $attributesMetalPurity: EbayArray_StringRequired_RequiredPutObject\n  $attributesMetal: EbayArray_StringRequired_RequiredPutObject\n  $attributesBeadSize: EbayArray_StringRequired_RequiredPutObject\n  $attributesRingSize: EbayArray_StringRequired_RequiredPutObject\n  $shippingPolicyId: EbayStringPutObject\n  $shippingPrimaryServicePaymentType: EbayStringPutObject\n  $domesticShippingService1: EbayStringPutObject\n  $domesticShippingPrice1: EbayIntPutObject\n  $shippingIntlPrimaryServicePaymentType: EbayStringPutObject\n  $intlShippingService1: EbayStringPutObject\n  $intlShippingPrice1: EbayIntPutObject\n  $offerGlobalShipping: EbayBooleanRequiredPutObject\n  $offerLocalPickup: EbayBooleanRequiredPutObject\n  $localPickupPrice: EbayIntPutObject\n) {\n  ebayPutEbayListing(listingId: $listingId, categoryId: $categoryId, pictureIds: $pictureIds, price: $price, condition: $condition, title: $title, description: $description, attributes: $attributes, upc: $upc, isbn: $isbn, attributesBrand: $attributesBrand, attributesColor: $attributesColor, attributesStyle: $attributesStyle, attributesItemHeight: $attributesItemHeight, attributesItemLength: $attributesItemLength, attributesItemWidth: $attributesItemWidth, attributesType: $attributesType, attributesMaterial: $attributesMaterial, attributesNumberOfItemsInSet: $attributesNumberOfItemsInSet, attributesSetIncludes: $attributesSetIncludes, attributesBandMaterial: $attributesBandMaterial, attributesDepartment: $attributesDepartment, attributesDressLength: $attributesDressLength, attributesOuterShellMaterial: $attributesOuterShellMaterial, attributesFrameColor: $attributesFrameColor, attributesUpperMaterial: $attributesUpperMaterial, attributesInseam: $attributesInseam, attributesSleeveLength: $attributesSleeveLength, attributesDesignerBrand: $attributesDesignerBrand, attributesExteriorMaterial: $attributesExteriorMaterial, attributesExteriorColor: $attributesExteriorColor, attributesSkirtLength: $attributesSkirtLength, attributesMainStone: $attributesMainStone, attributesMetalPurity: $attributesMetalPurity, attributesMetal: $attributesMetal, attributesBeadSize: $attributesBeadSize, attributesRingSize: $attributesRingSize, shippingPolicyId: $shippingPolicyId, shippingPrimaryServicePaymentType: $shippingPrimaryServicePaymentType, domesticShippingService1: $domesticShippingService1, domesticShippingPrice1: $domesticShippingPrice1, shippingIntlPrimaryServicePaymentType: $shippingIntlPrimaryServicePaymentType, intlShippingService1: $intlShippingService1, intlShippingPrice1: $intlShippingPrice1, offerGlobalShipping: $offerGlobalShipping, offerLocalPickup: $offerLocalPickup, localPickupPrice: $localPickupPrice) {\n    success\n  }\n}\n',
    },
  };
})();
(node as any).hash = '2a3885df80519649343257ce7ad1212f';
export default node;
